export default __webpack_public_path__ + "static/media/share_code.6d3a2936.svg";